import * as React from "react";
import { Form, Input, Button, InputOnChangeData } from "semantic-ui-react";

interface Props {
    notes: string;
    label: string | number;
    readonly: boolean;
    allowNotes: boolean;
    onUpdate: (value: string) => void;
    onRemove: () => void;
}

export const ImageAnnotatorQuestionPointActions: React.FunctionComponent<Props> = (props) => {
    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => props.onUpdate(data.value);

    return (
        <Form.Field inline>
            <label>{props.label}</label>
            {props.readonly ?
                <span>{props.notes}</span> :
                <>
                    {props.allowNotes && <Input value={props.notes} onChange={onInputChange} />}
                    <Button
                        icon="remove"
                        secondary
                        onClick={props.onRemove}
                        type="button"
                    />
                </>
            }
        </Form.Field>
    );
};
